import utils from "../../../utils/utils.js";

export default {
  async fetchKeywords(context,payload) {
  const params = payload.keywordTypeList.map(id => `typeList=${id}`).join("&");
    const response = await utils.utility.fetch(
      `api/Setting/GetKeywords?${params}`,
      "GET",
      null,
      null
    );
    context.commit("setKeywords", response.data); // Mutation'ı tetikle
  },
  async fetchBannedWords(context) {
    // const userToken = context.rootGetters.token;
    const response = await utils.utility.fetch(
      `api/Setting/GetKeywords?typeList=3`,
      "GET",
      null,
      null
    );

    context.commit("setBannedWords", response.data);
  },
  async postKeyword(context, payload) {
    //  let postData =JSON.stringify( payload);

    let postData = payload;

    if (payload.keywordId) {
      await utils.utility.fetch(
        `api/Setting/UpdateKeyword`,
        "POST",
        null,
        payload
      );
      //post server
    } else {
      await utils.utility.fetch(
        `api/Setting/InsertKeyword`,
        "POST",
        null,
        postData
      );
    }
   // await this.$store.dispatch("fetchKeywords",{keywordTypeList:[1,2]});
    await context.dispatch("fetchKeywords", { keywordTypeList: [1, 2] });

    //post server - bu post yeni eklenen verinin ID'sini dönmeli. Ardından mutation ekleyip güncel array'e push'la
    
  },
  async postBannedWord(context, payload) {
    let postData = {
      text: payload.bannedWord,
      type: 3,
    };
    
    await utils.utility.fetch(
      `api/Setting/InsertBannedKeyword`,
      "POST",
      null,
      postData
    );
    //post server

    await context.dispatch("fetchBannedWords");

    //hem post keyword'te hem de burada context'i güncellemek gerekebilir. Tabloyu incelemek gerek
  },
  async deleteBannedWord(context, payload) {
    const bannedWordId = payload.id;
    
    let postData = {
      id: bannedWordId,
    };
    
    await utils.utility.fetch(
      `api/Setting/DeleteKeyword`,
      "POST",
      null,
      postData
    );
    
    // Yasaklı kelime silindikten sonra listeyi yeniden çek
    await context.dispatch("fetchBannedWords");
    await context.dispatch("fetchKeywords", { keywordTypeList: [1, 2] });
  },
  async fetchTagTypes(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetTagFlagTypes`,
      "GET",
      null,
      null
    );

    // const response = await fetch("https://sniffer-v3-dummy-backend-default-rtdb.europe-west1.firebasedatabase.app/tagTypes.json");

    context.commit("setTagTypes", response.data);
  },

  async deleteKeywordTag(context, payload) {
    const id = payload.id;
    let postData = {
      id: id
    };

    
      const response = await utils.utility.fetch(
        `api/Setting/DeleteKeywordTag`,
        "POST",
        null,
        postData
      );

      if (response.status === 200) {
        context.commit("deleteKeywordTag", payload);
      }
    

    context.commit("deleteKeywordTag", payload);
  },
  async deleteKeyword(context, payload) {
    const keywordId = payload.id;
    //post server

    let postData = {
      id: keywordId,

    };
    await utils.utility.fetch(
      `api/Setting/DeleteKeyword`,
      "POST",
      null,
      postData
    );
    
    // Keyword silindikten sonra listeyi yeniden çek
    await context.dispatch("fetchKeywords", { keywordTypeList: [1, 2] });
  },

  async fetchKeywordVariation(context, payload) {
    const keywordId = payload.id;
    const response = await utils.utility.fetch(
      `api/Setting/GetKeywordVariations?keywordid=${keywordId}`,
      "GET",
      null,
      null
    );

    const keywordVariations = response.data.map((item) => item.text);

    let senddata = { id: keywordId, variations: keywordVariations };
    context.commit("setKeywordVariations", senddata);
  },

  async fetchKeywordDetail(context, payload) {
    const keywordId = payload.id;
    const response = await utils.utility.fetch(
      `api/Setting/GetKeywordDetails?keywordid=${keywordId}`,
      "GET",
      null,
      null
    );
    context.commit("setKeywordDetail", response.data);
  },
  async postKeywordTag(context, payload) {
    let postData = {
      text: payload.tag,
      keywordId: payload.keywordId,
      tagType: payload.tagType,
    };

    await utils.utility.fetch(`api/Setting/InsertTag`, "POST", null, postData);

    await context.dispatch("fetchKeywordTags", payload);
  },
  async fetchKeywordTags(context, payload) {
    const keywordId = payload.keywordId;

    
      const response = await utils.utility.fetch(
        `api/Setting/GetKeywordTags?keywordid=${keywordId}`,
        "GET",
        null,
        null
      );
      context.commit("setKeywordTags", response.data); // Vuex state'i güncelle

  },

  async fetchActiveSources(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetSourcesBySearchType`,
      "GET",
      null,
      null
    );
    context.commit("setActiveSource", response.data);
  },
};